export default __webpack_public_path__ + "static/media/1584.95442746.png";